class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHover();
  }

  setupHover() {
    if (window.matchMedia('(hover: hover)').matches) {
      let closeTimeout;

      this.addEventListener('mouseenter', () => {
        clearTimeout(closeTimeout);
        // Close other open menus
        document.querySelectorAll('header-menu').forEach((menu) => {
          if (menu !== this && menu.mainDetailsToggle.open) menu.close();
        });
        this.open();
      });

      this.addEventListener('mouseleave', () => {
        closeTimeout = setTimeout(() => this.close(), 150);
      });
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    if (this.header) this.header.classList.add('mega-menu-open');
  }

  close() {
    super.close();
    // Remove header class if no mega menus are open
    const anyOpen = document.querySelector('header-menu details[open]');
    if (!anyOpen && this.header) this.header.classList.remove('mega-menu-open');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.header.classList.add('mega-menu-open');
    } else {
      const anyOpen = document.querySelector('header-menu details[open]');
      if (!anyOpen) this.header.classList.remove('mega-menu-open');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
